// #284/#239, Session 74z. The left column was one unsegmented scroll of four
// stacked sections. It is now three tabs, divided by WHOSE COURT THE BALL IS IN
// rather than by status name: Needs action (the buyer is the blocker), Pending
// spend approval (an admin or executive is), On order (the vendor is).
// Extracted from PurchasingQueuePage.js at Session 79.14c.
//
// Tabs are safe on this screen specifically, which is not generally true of
// queues: the stat strip above already renders a live count for every stage, so
// tabbing hides no number. That is the usual objection and it does not apply.
//
// "Ordered" is renamed "On order" deliberately. It is a chase-the-vendor surface
// — tracking numbers, ETAs, follow-up, and (74z3) closing a line short — and
// "Ordered" reads as an archive, which is the opposite of what it is.
// mobileLabel, Session 79.14. MEASURED, not guessed: at 375px the three pills
// came to 366px inside a 347px row - OVERFLOWING BY 19px, so "On order" was
// clipped at the right edge and the only way to reach it was a horizontal scroll
// with nothing on screen saying it was there.
//
// One label was the outlier. "Pending spend approval" rendered at 157px against
// 98px and 76px for the other two. Dropping "Pending" - which the tab's own
// count already implies, and which neither sibling tab says - brings the row
// inside the screen with room to spare.
//
// THE WORD "SPEND" IS KEPT DELIBERATELY. That is #231's disambiguation: this tab
// is about a DOLLAR THRESHOLD, and a bare "Approval" would collide with the
// Requests inbox's unrelated manager-approval tab, which is the confusion #231
// exists to record. Shortening past "spend" would undo it.
//
// Desktop keeps the full label - it has the room and never overflowed.
//
// THAT PREMISE CHANGED AT SESSION 79.14d AND COLBY CAUGHT IT ON THE LIVE SCREEN:
// "i dont like how the tab names extend past the left column border." He was
// exactly right and it was measurable. This strip governs the 420px left-hand
// list and was rendered ACROSS THE WHOLE PAGE - the left column ends at x=500
// and the tab row ran to x=1528, so "On order" straddled the boundary at 429 to
// 537. It had always been that way; #304's search box, which is the same width
// and sits directly above it, is what made it obvious.
//
// The strip now lives INSIDE the column, so `compact` exists: at 420px the full
// labels come to 421px against 404px of usable room, which is #540's clipped-tab
// defect again one screen over. Compact uses the short label and tighter padding
// and measures 391px. THE WORD "SPEND" SURVIVES, which is the one thing that
// could not be dropped - see #231 above.

import React from 'react';

export const QUEUE_TABS = [
  { id: 'needs_action', label: 'Needs action' },
  { id: 'pending_approval', label: 'Pending spend approval', mobileLabel: 'Spend approval' },
  { id: 'on_order', label: 'On order' },
];

// Purchasing's locked domain colour is #EF9F27. It carries the 2px active
// underline, where it is a graphic element, while #9A5F00 carries the label.
// #EF9F27 as text on white sits near 2:1 contrast and would fail legibility on
// the priority surface, so the domain colour is expressed where it can be seen
// rather than where it cannot be read. CORRECTED at #658 (Session 79.22b): this
// called #BA7517 "the readable amber" -- it was darker, and was never measured.
// It reads 3.72 on white against the 4.5 a 12.5px label needs; #9A5F00, the
// app's warning text since #617, reads 5.24.
// needsActionTabRef — callouts gate Wave 2, pur_queue_tabs_first. One ref on one
// element (the first tab), passed in rather than created here so the callout can
// live where the viewer's role is known. #38's first failure mode is one ref on
// two nodes, where whichever mounts later silently wins.
export default function QueueTabs({ activeTab, setActiveTab, counts, isMobile, needsActionTabRef, compact = false }) {
  if (isMobile) {
    return (
      <div style={{ display: 'flex', gap: 6, overflowX: 'auto', padding: '9px 12px', background: 'white', borderBottom: '1px solid #E8E8E8' }}>
        {QUEUE_TABS.map(t => (
          <button key={t.id} ref={t.id === 'needs_action' ? needsActionTabRef : undefined} onClick={() => setActiveTab(t.id)}
            style={{
              fontSize: 11, fontWeight: 700, padding: '6px 10px', borderRadius: 14, whiteSpace: 'nowrap',
              border: 'none', cursor: 'pointer',
              background: activeTab === t.id ? '#EF9F27' : '#F0F0F0',
              color: activeTab === t.id ? '#0F0F0F' : '#5C5C5C',
            }}>
            {t.mobileLabel || t.label} {counts[t.id]}
          </button>
        ))}
      </div>
    );
  }
  return (
    <div style={{ display: 'flex', borderBottom: '1px solid #E8E8E8', padding: compact ? '0 8px' : '0 16px', background: '#F7F7F6', flexShrink: 0 }}>
      {QUEUE_TABS.map(t => {
        const on = activeTab === t.id;
        return (
          <button key={t.id} ref={t.id === 'needs_action' ? needsActionTabRef : undefined} onClick={() => setActiveTab(t.id)}
            style={{
              padding: compact ? '11px 10px' : '11px 15px', fontSize: 12.5, fontWeight: 600, whiteSpace: 'nowrap',
              display: 'flex', alignItems: 'center', gap: 7, cursor: 'pointer',
              // Longhand on all four sides. Mixing the `border` shorthand with a
              // `borderBottom` longhand on the same element makes React warn on every
              // rerender and drop one of them - the same defect 74t fixed in
              // Overlay.js. Surfaced here by live test, in the console rather than on
              // screen, which is why the console gets read rather than glanced at.
              borderTop: 'none', borderLeft: 'none', borderRight: 'none',
              borderBottom: '2px solid ' + (on ? '#EF9F27' : 'transparent'),
              background: on ? 'white' : 'transparent',
              color: on ? '#9A5F00' : '#7A7A7A',
            }}>
            {compact ? (t.mobileLabel || t.label) : t.label}
            <span style={{
              fontSize: 10, fontWeight: 700, borderRadius: 9, padding: '1px 6px', minWidth: 18, textAlign: 'center',
              background: on ? '#EF9F27' : '#F0F0F0', color: on ? '#0F0F0F' : '#5C5C5C',
            }}>{counts[t.id]}</span>
          </button>
        );
      })}
    </div>
  );
}
